module.exports = __webpack_public_path__ + "4-84.jpg?800f609ce6ba54d609d5f23c197a749a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-84.jpg
// module id = 165
// module chunks = 0